import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutRoutingModule } from './checkout-routing.module';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { SharedModule } from '@shared/shared.module';
import { PaymentResponsePage } from './payment-response/payment-response.page';
import { PaymentTransferPage } from './payment-transfer/payment-transfer.page';
import { PaymentTypeComponent } from './payment-type/payment-type.component';

@NgModule({
  declarations: [PaymentResponsePage, PaymentTransferPage, PaymentTypeComponent],
  imports: [CommonModule, FormsModule, IonicModule, SharedModule, TranslocoModule, CheckoutRoutingModule],
  exports: [PaymentResponsePage, PaymentTransferPage],
})
export class CheckoutModule {}
